import { WecomRemoveCustomerToRoomData } from "../..";
import EventBus from "../event-bus";

const removeCustomerToRoomHook = new EventBus<WecomRemoveCustomerToRoomData>(
  "removeCustomerToRoomHook"
);

export default removeCustomerToRoomHook;
